import { cx } from '@linaria/atomic';
import { Info, Heading, TextButton } from '@frontend/design-system';
import { SettingsGroupStyles } from './settings-group.styles';

type SettingsGroupProps = {
  children: React.ReactNode;
  title: string;
  actionLabel?: string;
  actionButtonTrackingId?: string;
  infoText?: string;
  disabledInfo?: boolean;
  disabledAction?: boolean;
  onActionClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  maxWidth?: number | string;
  condensed?: boolean;
};

export const SettingsGroup = ({
  children,
  title,
  disabledInfo,
  infoText,
  actionLabel,
  actionButtonTrackingId,
  onActionClick,
  disabledAction,
  maxWidth = 700,
  condensed = false,
}: SettingsGroupProps) => {
  return (
    <section
      className={SettingsGroupStyles.settingsGroupSectionStyle1}
      style={{
        maxWidth,
      }}
    >
      <header
        className={cx(
          SettingsGroupStyles.settingsGroupHeaderStyle3,
          condensed ? SettingsGroupStyles.headerCondensed : SettingsGroupStyles.headerStandard
        )}
      >
        <Heading className={SettingsGroupStyles.settingsGroupHeadingStyle4} level={3}>
          {title}
        </Heading>
        {infoText && (
          <Info disabled={disabledInfo} color='light' className={SettingsGroupStyles.settingsGroupInfoStyle5}>
            {infoText}
          </Info>
        )}
        {actionLabel && (
          <TextButton
            trackingId={actionButtonTrackingId}
            onClick={onActionClick}
            disabled={disabledAction}
            variant='rounded'
            className={SettingsGroupStyles.settingsGroupTextButtonStyle6}
          >
            {actionLabel}
          </TextButton>
        )}
      </header>
      {children}
    </section>
  );
};
